module.exports = __webpack_public_path__ + "img/hover_icon_manejo_ajuste_facturacion.0608afe1.svg";